import React from "react";
import MarketingNav from "@/components/MarketingNav";
import Seo from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";
import { BIZ } from "@/data/site";

export default function TermsPage() {
  const updated = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  return (
    <div className="bg-paper min-h-screen">
      <Seo title="Terms & Estimate Disclaimer" description="Website terms and estimate calculator disclaimer for Wynridge Exterior Cleaning." path="/terms-and-estimate-disclaimer/" />
      <MarketingNav />
      <article className="pt-36 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-stone">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">Legal</div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-stone-900" style={{ fontFamily: "Outfit" }}>Terms &amp; Estimate Disclaimer</h1>
          <p className="text-sm text-stone-500">Last updated: {updated}</p>

          <h2>Estimate disclaimer</h2>
          <p><b>Calculator results are preliminary estimates and are not a binding quote.</b> Final pricing is confirmed after we review the property details, photos, or complete an on-site evaluation. Height, access, organic growth, obstacles, water availability, condition of the surfaces, and any requested add-ons can move the final price up or down.</p>

          <h2>Service scope &amp; outcomes</h2>
          <p>We use professional-grade equipment and appropriate detergents for each surface. Some outcomes depend on factors outside our control — for example, the age, depth, and porosity of concrete stains, weathering of wood decks, and the composition of roof algae. We do not guarantee removal of every oil, rust, or permanent stain, and we do not warrant against natural re-growth of mildew or algae over time.</p>

          <h2>Property access</h2>
          <p>Customer is responsible for granting site access, unlocking gates, moving fragile items indoors, and disclosing any known hazards (loose siding, weak decking, buried lines, sensitive plants). We&apos;ll pre-soak sensitive landscaping and do our best to work carefully, but pre-existing damage or hidden defects are not covered.</p>

          <h2>Cancellations</h2>
          <p>Please provide at least 24 hours&apos; notice for cancellations or reschedules. Same-day cancellations may incur a small trip fee.</p>

          <h2>Payment</h2>
          <p>Payment is due on the day of service unless a written invoicing agreement is in place (typical for HOA and commercial work).</p>

          <h2>Insurance</h2>
          <p>{BIZ.name} carries general liability insurance. A certificate of insurance is available on request.</p>

          <h2>Text messages</h2>
          <p>By submitting your phone number you consent to service-related text messages from {BIZ.name}. Reply STOP to opt out. Message and data rates may apply.</p>

          <h2>Website use</h2>
          <p>This website is provided as-is for informational purposes. We work to keep the info accurate but do not warrant that every price, availability, or claim is current.</p>

          <h2>Contact</h2>
          <p>Questions? <a href={`mailto:${BIZ.email}`}>{BIZ.email}</a> or {BIZ.phone}.</p>
        </div>
      </article>
      <SiteFooter />
    </div>
  );
}
